
/**
 * Determines if element is in view
 * @param {string} element
 * @return {string} returns true if element is completely visible and false otherwise
 */
function isInView (element: any) {
  const bounding = element.getBoundingClientRect()

  return (bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export { isInView }
